var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1048 12.4199L26.629 16.2669C27.4902 16.8672 28.0019 17.8464 28 18.8903V24.5928C27.9979 25.4986 27.633 26.3664 26.9857 27.0054C26.3384 27.6443 25.4617 28.0021 24.5484 28H15.4516C14.5383 28.0021 13.6616 27.6443 13.0143 27.0054C12.367 26.3664 12.0021 25.4986 12 24.5928V18.8903C11.9981 17.8464 12.5098 16.8672 13.371 16.2669L18.8952 12.4199C19.5236 11.86 20.4764 11.86 21.1048 12.4199ZM21.1774 23.2012L25.5887 20.154L25.5565 20.1939C25.7336 20.0711 25.8313 19.8638 25.8126 19.6502C25.7939 19.4366 25.6617 19.249 25.4658 19.1583C25.2699 19.0675 25.0401 19.0873 24.8629 19.2102L20.3952 22.3054C20.2629 22.4366 20.0813 22.507 19.8944 22.4994C19.7075 22.4918 19.5323 22.4069 19.4113 22.2654L15.0726 19.2102C14.8078 19.0387 14.454 19.1018 14.2661 19.3542C14.0973 19.6176 14.1605 19.9654 14.4113 20.154L18.6855 23.1612C19.0381 23.4815 19.4977 23.6609 19.9758 23.6651C20.4213 23.6678 20.851 23.5019 21.1774 23.2012Z",
    fill: "#8CA3A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.179280ff83b0910f4370c9fa146759c2.svg";
export { ForwardRef as ReactComponent };